module.exports = __webpack_public_path__ + "img/index.35e258a4.png";